import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { ListItem } from '@material-ui/core';

import { CloudStatus } from './types';
import ProgressBar from './ProgressBar';

function PendingRequestsStatus({
  todo,
  syncing,
  progress,
  time,
}: Pick<CloudStatus, 'todo' | 'syncing' | 'progress' | 'time'>) {
  const { t } = useTranslation('header');

  if (!syncing) {
    if (todo) {
      return (
        <Trans
          i18nKey="header:sync.requests.waiting"
          tOptions={{ todo }}
          parent="span"
        >
          <strong />
        </Trans>
      );
    }
    return (
      <>
        <div>{t('sync.requests.done1')}</div>
        <div>
          {t('sync.requests.done2', {
            time: time.toLocaleTimeString(),
          })}
        </div>
      </>
    );
  }

  if (todo || progress) {
    return (
      <Trans
        i18nKey="header:sync.requests.processing"
        tOptions={{ progress, todo }}
        parent="span"
      >
        <strong />
      </Trans>
    );
  }
  return <div>{t('sync.requests.done1')}</div>;
}

function PendingRequests({
  time,
  todo,
  syncing,
  progress,
  done,
}: Pick<CloudStatus, 'time' | 'todo' | 'syncing' | 'progress' | 'done'>) {
  const { t } = useTranslation('header');
  return (
    <ListItem
      data-testid="pending-requests"
      divider
      style={{
        justifyContent: 'center',
        flexDirection: 'column',
        minWidth: 'min(345px, 80vw)',
      }}
    >
      <strong>{t('sync.requests.title')}</strong>
      <PendingRequestsStatus
        todo={todo}
        syncing={syncing}
        progress={progress}
        time={time}
      />
      {syncing ? (
        <ProgressBar
          step={progress}
          done={done}
          total={todo + progress + done}
        />
      ) : null}
    </ListItem>
  );
}

export default PendingRequests;
